@if (mileageChartData$ | async; as chartData) {
  <div class="chart-wrapper">
    <div class="chart-wrapper__canvas">
      @if (
        chartData.get(chartType.MileageDistribution);
        as mileageDistribution
      ) {
        <div class="chart-wrapper__canvas--line-chart">
          <div
            class="chart-wrapper__canvas--line-chart--content"
            echarts
            [options]="mileageDistribution"></div>
        </div>
      }
      @if (
        chartData.get(chartType.MileageDistributionDOW);
        as mileageDistributionDOW
      ) {
        <div class="chart-wrapper__canvas--bar-chart">
          <div
            class="chart-wrapper__canvas--bar-chart--content"
            echarts
            [options]="mileageDistributionDOW"></div>
        </div>
      }
    </div>
    <div class="chart-wrapper__total">
      <app-statistics-total
        [totalData]="chartData.get(chartType.MileageTotal)"
        [titleKey]="chartTitle[chartType.MileageTotal]"></app-statistics-total>
    </div>
  </div>
}
